import Get from "../Get";

import getToken from "../token";

export default function tagRating() {
  
  return Get("counseling/rating/tagList", {});
}
